import React from 'react'

class PresaiComponent extends React.Component {
    render() {
        return <div className="contentPresai">
        <h1 >Briketų presai</h1>

    
    <div  id="dsc">
            <div  className="videoHolder">
                    <iframe  allowfullscreen="" frameborder="0" height="315" width="420" src="https://www.youtube.com/embed/F52MDI0Iyvk"></iframe>
            </div>

        

        <div  className="press hydraulic"><b >Hidrauliniai briketų presai  18,5;  30 Kw</b>

            <br/>
              Presavimui galima naudoti šiaudus, pjuvenas, durpes ir kitą biomasę bei makulatūrą.
              Briketo dydis : 60x120x80 arba "Ruf" forma (60x150x80)</div>
        <div  className="press stumuokliniai">
            <div>
 
            </div>

                <b >Stūmokliniai (mechaniniai) briketų presai</b>
                Presai gamina is šiaudų, pjuvenų, saulegražų lukštų
                    našumas priklauso nuo preso galingumo ir žaliavos:
                    18,5 Kw -300-400 kg/h šiaudai 400-500 kg/h pjuvenos
                    sudetis
                    briketų presas   – 1 vnt. 
                    <ul >
                      <li >
                          žaliavos bunkeris su maišytuvu 1,5m3  2,2 Kw– 1 vnt
                      </li>
                      <li >
                          briketų stabilizatorius – 1 kompl. 
                      </li>
                      <li >
                          valdymo spinta – 1vnt.
                      </li>
                      <li >
                          laipteliai  .1 vnt
                      </li>
                    </ul>
                    Ilgis 8,9m
                    plotis 1,4m
    
                <p >
                    22 kw 450-600 kg/h šiaudai; 500-800 kg/h pjuvenos
                    sudetis
                    briketų presas   – 1 vnt. 
                    </p><ul >
                      <li >
                          žaliavos bunkeris su maišytuvu 1,5m3; 2,2 Kw  – 2 vnt
                      </li>
                      <li >
                          briketų stabilizatorius – 2 kompl.
                      </li>
                      <li >
                          valdymo spinta – 1vnt.
                      </li>
                      <li >
                          laipteliai  .1 vnt 
                      </li>
                    </ul>                ilgis su stabilizatoriais 8,9m 
                    plotis 1,4m 
        </div>

        <div className="pressGallery">
            <img  className="pressImages" src={require("./presai/1.jpg")}/>
            <img className="pressImages"  src={require("./presai/stumuokliniai.jpg")}/>
                    <img className="pressImages" src={require("./presai/stumuokliniai2.jpg")}/>
        </div>
            

            

            
        
    </div>

</div>
    }
}

export default PresaiComponent